module.exports = __webpack_public_path__ + "static/media/01_3.4f36c7ff.png";